import { render, staticRenderFns } from "./AdminBlogs.vue?vue&type=template&id=4ffde004&scoped=true"
import script from "./AdminBlogs.vue?vue&type=script&lang=js"
export * from "./AdminBlogs.vue?vue&type=script&lang=js"
import style0 from "./AdminBlogs.vue?vue&type=style&index=0&id=4ffde004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffde004",
  null
  
)

export default component.exports